import { ToggleAccordionButton } from "../../shared/scripts/ldn-accordion";
export class LdnPage {
    constructor() {
        ToggleAccordionButton();
    }
}